import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@heroui/react';
import { cn, getNodeTestIdProp } from '@/utils';
import type { PaymentMethod } from '../paymentMeta';

type PaymentEntryNoticeProps = {
    /** `pages` key: `usePaymentFlow`'s `entryNoticeKey`. */
    messageKey: string | null;
    method: PaymentMethod;
};

const SLOT_HEIGHT: Record<PaymentMethod, string> = {
    cash: 'h-20',
    combined: 'h-28',
    card: 'h-32',
};

/**
 * Render-only: why the typed amount can't confirm (SEL-50) — too large (most
 * likely a barcode scanned into payment), or a cash tender short of the due
 * after `Enter`. The slot stays mounted so the centered dialog never
 * changes height when a notice appears. Only the message is an alert.
 */
export const PaymentEntryNotice: React.FC<PaymentEntryNoticeProps> = ({
    messageKey,
    method,
}) => {
    const { t } = useTranslation('pages');

    return (
        <div className={cn('w-full overflow-y-auto', SLOT_HEIGHT[method])}>
            {messageKey ? (
                <Alert
                    {...getNodeTestIdProp('seller-pay-entry-notice')}
                    role="alert"
                    status="danger"
                >
                    <Alert.Indicator />
                    <Alert.Content>
                        <Alert.Title>{t(messageKey)}</Alert.Title>
                    </Alert.Content>
                </Alert>
            ) : null}
        </div>
    );
};
